document.addEventListener("DOMContentLoaded", () => {
  const $bundleForm = $(".diy-bundle-form");
  const $setItems = $(".diy-bundle-set-items");
  const $addCartButton = $(".diy-bundle-btn");
  const $originTotal = $(".original-total-price");
  const $discountTotal = $(".discount-total-price");
  const $optionItem = $(".dialog-quickview__swatch__item");
  const $colorItem = $(".option-color-item");
  let setItems = [];
  const MIN_BOX_COUNT = 4;
  function getDiscountConfig() {
    return {
      accs: parseFloat($bundleForm.attr("data-accs-discount")) || 0.12,

      system: parseFloat($bundleForm.attr("data-system-discount")) || 0.15,

    };

  }



  function countByPickType(items) {

    const counts = { base: 0, accs: 0, system: 0 };

    items.forEach((item) => {

      const type = item.pickType || "base";

      if (counts[type] !== undefined) {

        counts[type] += 1;

      }

    });

    return counts;

  }



  function resolveItemDiscountRates(items) {

    const config = getDiscountConfig();

    const counts = countByPickType(items);



    if (counts.base === 0 || (counts.accs === 0 && counts.system === 0)) {

      return items.map(() => 0);

    }



    if (counts.accs > 0 && counts.system > 0) {

      return items.map((item) => {

        if (item.pickType === "accs") return config.accs;

        return config.system;

      });

    }



    if (counts.system > 0) {

      return items.map(() => config.system);

    }



    return items.map(() => config.accs);

  }



  // 初始化显示指定数量的方框
  function initializeBoxes(count) {
    for (let i = 0; i < count; i++) {
      addEmptySlot();
    }
  }

  // 添加一个空方框
  function addEmptySlot() {
    $setItems.append(`
                    <div class="set-item empty">
                        <span class="add-icon">+</span>
                    </div>
                `);
  }

  $(document).on("click", ".add-to-set", function () {
    const $this = $(this);
    if ($this.hasClass("not-buy")) return;

    var productId = $this.attr("data-variant-id");
    var productPrice = $this.attr("data-price");
    var productImg = $this.attr("data-img");
    var productRequired = $this.attr("required_status");
    var pickType = $this.attr("data-pick-type") || "base";

    if (!productId) return;

    setItems.push({
      id: productId,
      price: productPrice,
      img: productImg,
      required: productRequired,
      pickType: pickType,
      uniqueKey: Date.now() + Math.random(),
    });

    renderSetItems();

    if (setItems.length > 0) {
      $addCartButton.addClass("active");
    }

    arrangeId();

    $this.closest("dialog-quickview").find(".dialog-quickview__close").trigger("click");
  });

  // 渲染集合项
  function renderSetItems() {
    $setItems.empty();



    const discountRates = resolveItemDiscountRates(setItems);



    setItems.forEach((item, index) => {

      const itemDiscount = discountRates[index] || 0;

      const discountPercent =

        itemDiscount > 0 ? Math.round(itemDiscount * 100) : 0;

      const safeName = String(item.name || "")
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

      const removeLabelTemplate =
        $setItems.attr("data-remove-label") || "Remove %title% from set";
      const removeLabel = removeLabelTemplate
        .replace(/%title%/g, item.name || "")
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

      const $item = $(`
                        <div class="set-item" data-id="${
                          item.id
                        }" data-unique="${item.uniqueKey}">
                            <img src="${item.img}" alt="${safeName}">
                            <button type="button" class="remove" aria-label="${removeLabel}">×</button>
                            <span class="set-item-discount" discount="${itemDiscount}">${

        discountPercent > 0 ? `-${discountPercent}%` : ""

      }</span>
                        </div>
                    `);

      // 移除集合项的逻辑
      $item.find(".remove").on("click", function () {
        const $setItem = $(this).closest(".set-item");
        const uniqueKey = $setItem.data("unique");

        // 从数据中移除特定的重复项
        setItems = setItems.filter((item) => item.uniqueKey !== uniqueKey);

        // 重新渲染
        renderSetItems();

        if (setItems.length < 1) {
          $addCartButton.removeClass("active");
        }
      });

      arrangeId();

      $setItems.append($item);
    });

    // 计算需要显示的方框数量
    let boxCount = setItems.length;
    // 如果产品数量小于最小方框数，显示最小方框数
    if (boxCount < MIN_BOX_COUNT) {
      boxCount = MIN_BOX_COUNT;
    } else {
      // 否则显示产品数量 + 1 个方框
      boxCount = setItems.length + 1;
    }

    // 添加空方框
    const emptySlotsNeeded = boxCount - setItems.length;
    for (let i = 0; i < emptySlotsNeeded; i++) {
      addEmptySlot();
    }

    calculativePrice();

    if (window.innerWidth <= 769 && $setItems.length) {
      const setItemsEl = $setItems.get(0);
      setItemsEl.scrollLeft = setItemsEl.scrollWidth;
    }
  }

  // 初始化页面，显示4个方框
  initializeBoxes(MIN_BOX_COUNT);

  function arrangeId() {
    const ids = setItems.map((item) => item.id).join(",");
    $addCartButton.attr("data-variant-id", ids);
  }

  function calculativePrice() {
    let originalTotal = 0;

    let discountedTotal = 0;

    const discountRates = resolveItemDiscountRates(setItems);



    setItems.forEach((item, index) => {

      const price = parsePrice(item.price);

      const rate = discountRates[index] || 0;

      originalTotal += price;

      discountedTotal += price * (1 - rate);

    });



    if (setItems.length === 0) {

      $originTotal.text("");

      $discountTotal.text("");

      return;

    }



    $originTotal.text(`$${formatPrice(originalTotal)}`);



    if (discountedTotal < originalTotal) {

      $discountTotal.text(`$${formatPrice(discountedTotal)}`);

    } else {

      $discountTotal.text("");

    }

  }

  // 解析价格

  function parsePrice(priceText) {
    // 1. 先移除所有非数字、非小数点和非逗号的字符
    let cleaned = priceText.replace(/[^0-9.,]/g, ""); // 2. 统计小数点和逗号的数量
    const dotCount = (cleaned.match(/\./g) || []).length;
    const commaCount = (cleaned.match(/,/g) || []).length; // 3. 根据逗号和小数点的数量决定如何处理
    if (commaCount > 0) {
      if (dotCount === 0) {
        // 情况1：只有逗号（如 "1,234" 或 "1,23"）
        // 将最后一个逗号替换为小数点，其他逗号视为千位分隔符
        const lastCommaIndex = cleaned.lastIndexOf(",");
        cleaned =
          cleaned.substring(0, lastCommaIndex) +
          "." +
          cleaned.substring(lastCommaIndex + 1);
        cleaned = cleaned.replace(/,/g, ""); // 移除其他逗号
      } else {
        // 情况2：既有逗号又有小数点（如 "1,234.56"）
        // 直接移除逗号
        cleaned = cleaned.replace(/,/g, "");
      }
    } // 4. 处理多个小数点的情况（保留最后一个小数点）
    cleaned = cleaned.replace(/\.(?=.*\.)/g, ""); // 5. 转换为数字，无效时返回0
    return Number(cleaned) || 0;
  }

  // 格式化价格（添加千位分隔符）
  function formatPrice(price) {
    return price.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  $optionItem.on("click", function () {
    const $this = $(this);
    setTimeout(function () {
      const $parent = $this.parents(".dialog-quickview");
      const imgSrc = $parent
        .find(".dialog-quickview__media-outer .swiper-slide-active img")
        .data("src");
      $parent.find(".add-to-set").attr("data-img", imgSrc);
    }, 0);
  });

  $colorItem.on("click", function () {
    const $this = $(this);
    const imgSrc = $this.data("image");
    const $parent = $this.parents(".bundle-product-card");
    $parent.find(".bundle-product-img").attr("srcset", imgSrc);
    $this.siblings(".option-color-item").removeClass("active");
    $this.addClass("active");
  });



  function resetViewMore($panel) {

    if (!$panel || !$panel.length) return;

    $panel.find(".hide-bundle-product").hide();

    $panel.find(".bundle-pro-list-btn").removeClass("active");

  }



  $(document).on("click", ".bundle-tag-filter", function () {
    const $btn = $(this);
    const filterIndex = $btn.attr("data-filter-index");
    const $productPanel = $btn.closest(".bundle-product-panel");



    $btn

      .addClass("active")

      .attr("aria-selected", "true")
      .attr("tabindex", "0")

      .siblings(".bundle-tag-filter")

      .removeClass("active")

      .attr("aria-selected", "false")
      .attr("tabindex", "-1");



    $productPanel.find(".bundle-filter-panel").each(function () {

      const $filterPanel = $(this);

      const panelIndex = $filterPanel.attr("data-filter-index");

      if (panelIndex === filterIndex) {

        $filterPanel.prop("hidden", false).addClass("active");

        resetViewMore($filterPanel);

      } else {

        $filterPanel.prop("hidden", true).removeClass("active");

      }

    });

  });



  $(document).on("click", ".bundle-step-tab", function () {

    const $tab = $(this);

    const tabIndex = $tab.attr("data-tab-index");

    const $tabsBox = $tab.closest(".bundle-tabs-box");



    $tab

      .addClass("active")

      .attr("aria-selected", "true")
      .attr("tabindex", "0")

      .siblings(".bundle-step-tab")

      .removeClass("active")

      .attr("aria-selected", "false")
      .attr("tabindex", "-1");



    $tabsBox.find(".bundle-step-panel").each(function () {

      const $stepPanel = $(this);

      const panelTabIndex = $stepPanel.attr("data-tab-index");

      if (panelTabIndex === tabIndex) {

        $stepPanel.prop("hidden", false).addClass("active");

        const $defaultFilterPanel = $stepPanel.find(

          '.bundle-filter-panel[data-filter-index="0"]'

        );

        $stepPanel

          .find(".bundle-tag-filter")

          .removeClass("active")

          .attr("aria-selected", "false")
          .attr("tabindex", "-1");

        $stepPanel

          .find('.bundle-tag-filter[data-filter-index="0"]')

          .addClass("active")

          .attr("aria-selected", "true")
          .attr("tabindex", "0");

        $stepPanel.find(".bundle-filter-panel").each(function () {

          const $filterPanel = $(this);

          if ($filterPanel.attr("data-filter-index") === "0") {

            $filterPanel.prop("hidden", false).addClass("active");

          } else {

            $filterPanel.prop("hidden", true).removeClass("active");

          }

        });

        resetViewMore($defaultFilterPanel);

      } else {

        $stepPanel.prop("hidden", true).removeClass("active");

      }

    });

  });



  $(document).on("click", ".bundle-pro-list-btn", function () {

    const $btn = $(this);

    const $filterPanel = $btn.closest(".bundle-filter-panel");

    const $productCards = $filterPanel
      .find(".bundle-product-list .hide-bundle-product");
    if ($btn.hasClass("active")) {
      $productCards.hide();
      $btn.removeClass("active");
    } else {
      $productCards.show();
      $btn.addClass("active");
    }
  });

  function activateTabInList($tabs, index) {
    const $target = $tabs.eq(index);
    if (!$target.length) return;
    $target.trigger("click").focus();
  }

  $(document).on("keydown", ".bundle-step-tab, .bundle-tag-filter", function (e) {
    const key = e.key;
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(key)) return;

    const $current = $(this);
    const $tabs = $current.siblings().addBack().filter(".bundle-step-tab, .bundle-tag-filter");
    const currentIndex = $tabs.index($current);
    if (currentIndex < 0) return;

    e.preventDefault();
    let nextIndex = currentIndex;
    if (key === "ArrowRight") nextIndex = (currentIndex + 1) % $tabs.length;
    if (key === "ArrowLeft") nextIndex = (currentIndex - 1 + $tabs.length) % $tabs.length;
    if (key === "Home") nextIndex = 0;
    if (key === "End") nextIndex = $tabs.length - 1;
    activateTabInList($tabs, nextIndex);
  });

  $(document).on("keydown", ".diy-bundle-btn", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    if (!this.classList.contains("active")) return;
    e.preventDefault();
    this.click();
  });
});
